// SafeChild Unified Theme
const T = {
  // Typography
  font: "'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  mono: "'JetBrains Mono', 'Fira Code', monospace",

  // Primary Colors
  blue: '#10B981',
  blueLight: '#34D399',
  blueDark: '#059669',
  blueSoft: '#ECFDF5',
  blueBorder: '#6EE7B7',

  // Semantic Colors
  green: '#10B981',
  greenSoft: '#ECFDF5',
  yellow: '#F59E0B',
  yellowSoft: '#FFFBEB',
  orange: '#F97316',
  coral: '#EF4444',
  coralSoft: '#FEF2F2',
  purple: '#8B5CF6',

  // Neutrals
  text: '#0F172A',
  textSec: '#475569',
  textMuted: '#94A3B8',
  bg: '#F8FAFC',
  bgDark: '#0F1D15',
  border: '#E2E8F0',
  borderLight: '#F1F5F9',

  // Shadows
  shadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -1px rgba(0,0,0,0.04)',
  shadowHover: '0 10px 25px -5px rgba(16,185,129,0.12), 0 8px 10px -5px rgba(0,0,0,0.02)',
  shadowModal: '0 25px 50px -12px rgba(0,0,0,0.25)',
};

export default T;
